var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c("p", [
        _vm._v(
          "Copy the following link and paste into your file explorer (or run window) to open the file or folder."
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-group" }, [
        _c("input", {
          ref: "linkInput",
          staticClass: "form-control",
          attrs: { type: "text", readonly: "" },
          domProps: { value: _vm.linkUrl },
          on: { focus: _vm.linkInputClick }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "input-group-append" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-text btn-copy",
              attrs: { type: "button", "data-dismiss": "modal" },
              on: { click: _vm.copyLink }
            },
            [_c("i", { class: _vm.copyIcon })]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }